export const COLORS = {
  SEMI_TRANSPARENT_WHITE: "#ffffffcf",
  DARKER_WHITE: "#F1F1F2",
  WHITE: "#ffffff",
  VERY_DARK_GRAY: "#222222",
  AI_RESULT_ACCEPTED_COLOR: "#36C2B4",
  AI_RESULT_OVERRIDE_COLOR: "#FFD814",
  IMAGE_UPLOADER_BORDER: "#00688D",
  IMAGE_UPLOADER_BORDER_IS_DRAGGING: "#007bff",
  IMAGE_UPLOADER_BG: "#fafafa",
  IMAGE_UPLOADER_BG_IS_DRAGGING: "#f0f8ff",
};
